import Vue from "vue";
import VueRouter from "vue-router";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import store from "@/store";

// 解决重复点击报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function (location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    redirect: "/user/login",
  },
  {
    path: "/admin/login",
    name: "adminLogin",
    meta: {
      title: "登录",
      display: 1,
    },
    component: (resolve) => require(["@/views/login/index"], resolve),
  },
  {
    path: "/user/login",
    name: "userLogin",
    meta: {
      title: "登录",
      display: 1,
    },
    component: (resolve) => require(["@/views/login/userLogin"], resolve),
  },
  {
    path: "/choose",
    name: "choose",
    meta: {
      title: "选择企业",
      display: 1,
    },
    component: (resolve) => require(["@/views/login/choose"], resolve),
  },
];

// 创建项目里的路由对象
const createRouter = () =>
  new VueRouter({
    mode: "history",
    scrollBehavior: () => ({
      y: 0,
    }),
    base: process.env.BASE_URL,
    routes,
  });

const router = createRouter();

// 设置重置路由的方法
export const resetRouter = () => {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
};

// 配置动态路由
const addDynamicRoute = () => {
  let menus = store.state.userMenu.length > 0 ? store.state.userMenu : [];


  // 父路由数组
  let dynamicRoute = [];
  for (let i = 0; i < menus.length; i++) {
    // 父路由配置
    // if(menus[i])
    dynamicRoute.push({
      path: menus[i].frontIndex,
      name: menus[i].frontName + "Name",
      component: () => import("@/views/home/index"),
      redirect: menus[i].redirect,
      children: [], //存放二级菜单
      meta: { title: menus[i].name, activeMenu: menus[i].activeMenu },
    });
    // 二级菜单
    for (let k = 0; k < menus[i].child.length; k++) {

      let routerObj = {

        path: menus[i].child[k].frontIndex,
        name: menus[i].child[k].frontName + "Name",
        component: () =>
          import(
            "@/views/" +
            menus[i].child[k].component.split("/")[2] +
            "/" +
            menus[i].child[k].component.split("/")[3]
          ),
        meta: {
          title: menus[i].child[k].name,
          activeMenu: menus[i].child[k].activeMenu,
        },
      };

      console.log('component: ', "@/views/" +
        menus[i].child[k].component.split("/")[2] +
        "/" +
        menus[i].child[k].component.split("/")[3]);


      dynamicRoute[dynamicRoute.length - 1].children.push(routerObj);
    }
  }
  // 
  router.addRoutes([
    ...dynamicRoute,
    {
      path: "*",
      component: () => import("@/views/errorPage/404.vue"),
    },
  ]);
};

//路由前置守卫
router.beforeEach((to, from, next) => {
  NProgress.start();

  let token = sessionStorage.getItem("token");
  let userType = sessionStorage.getItem("userType");
  let userMenu = store.state.userMenu || [];
  // 
  if (userType == "user") {
    if (to.path == "/user/login") {
      // 
      next();
    } else if (token && from.path == "/choose") {
      store.dispatch("UserMenu").then((res) => {
        // 动态路由添加
        addDynamicRoute();
        next();
      });
      // 
      next();
    } else if (token && from.path == "/user/login") {
      // 如果有token,并且是在登录页
      // 
      next();
    } else if (token && userMenu.length <= 0) {
      // 如果有token,并且matched为0，出现空白页面
      // 动态路由添加
      // 
      store.dispatch("UserMenu").then((res) => {
        addDynamicRoute();
        next();
      });
      next();
    } else if (!token && to.path !== "/user/login") {
      // 如果没有token,并且路径不是在login
      // 
      next("/user/login");
    } else {
      next();
    }
  } else if (userType == "userLogin") {
    if (token && from.path == "/choose") {
      store.dispatch("UserMenu").then((res) => {
        // 动态路由添加
        addDynamicRoute();
        next();
      });
      // 
      next();
    } else if (token && from.path == "/user/login") {
      // 如果有token,并且是在登录页
      store.dispatch("UserMenu").then((res) => {
        // 动态路由添加
        addDynamicRoute();
        next();
      });
      // 
      next();
    } else if (token && userMenu.length <= 0) {
      // 如果有token,并且matched为0，出现空白页面
      // 动态路由添加
      store.dispatch("UserMenu").then((res) => {
        addDynamicRoute();
        next();
      });
      // 
      next();
    } else if (token && !to.path == "/choose") {
      // 如果有token,并且matched为0，出现空白页面
      // 动态路由添加
      store.dispatch("UserMenu").then((res) => {
        addDynamicRoute();
        next();
      });
      // 
      next();
    } else if (!token) {
      // 如果没有token,并且路径不是在login
      // 
      next("/user/login");
    } else {
      // 
      next();
    }
  } else if (userType == "sysUser") {
    if (token && to.matched.length === 0) {
      store.dispatch("UserMenuAdmin").then((res) => {
        // 动态路由添加
        addDynamicRoute();
        if (to.path === "/login") {
          // 如果是从登录页刷新,并且有token,那么去到首页
          next();
        } else {
          next(to);
        }
      });
    } else if (token && !userMenu) {
      // 如果有token,并且matched为0，出现空白页面
      store.dispatch("UserMenuAdmin").then((res) => {
        // 动态路由添加
        addDynamicRoute();
      });
      next();
    } else if (token && to.path == "/login") {
      // 如果有token,并且是在登录页
      next();
    } else if (!token && to.path !== "/login") {
      // 如果没有token,并且路径不是在login
      next("/login");
    } else {
      next();
    }
  } else {
    next();
  }

  //
});

// 路由后置守卫
router.afterEach((to, from) => {
  NProgress.done(); // 进度条效果结束
  window.scrollTo(0, 0);
});

export default router;
